import { useCallback } from 'react'

import { apiUrl, useApiRequest } from '../useApiRequest'

/** Sends a new registration confirmation link to the signed-in user. */
export function useResendConfirmation() {
  const { run, loading } = useApiRequest()

  const resend = useCallback(
    () => run(({ poster }) => poster<void>(apiUrl('/account/register/confirmation'), undefined, 'application/json')),
    [run]
  )

  return { resend, loading }
}
